import React from 'react';
import { AlertTriangle } from 'lucide-react';

const BackupWarning = ({ className = '', onNavigateBackup }) => {
  const handleClick = (e) => {
    e.preventDefault();
    if (onNavigateBackup) {
      onNavigateBackup();
    }
  };

  return (
    <div className={`fixed inset-x-0 top-0 z-50 bg-yellow-100 border-b border-yellow-200 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-center">
        <AlertTriangle size={24} className="mr-3 text-yellow-600" />
        <span className="text-yellow-800 font-medium text-center">
          Non è stato eseguito un backup negli ultimi 7 giorni. Si consiglia di effettuare un{' '}
          <button
            type="button"
            onClick={handleClick}
            className="underline text-yellow-900 hover:text-yellow-700 focus:outline-none"
          >
            backup del database
          </button>.
        </span>
      </div>
    </div>
  );
};

export default BackupWarning;